// Average width of a . is 3px. . is thinnest character so it's width is used
// to find the cut off of string that might fit within given line number and width
// to quicken the truncating process
const APPROX_WIDTH_OF_A_PERIOD = 3;

/**
 * Truncates a string to fit the given number of lines for given width of element.
 * @method truncateSnippet
 * @param {String} snippet string of text to be truncated.
 * @param {Number} desiredWidth width of element where the snippet is to render
 * @param {Number} desiredNumberOfLines string to truncate after this number of lines
 */
const truncateSnippet = (
  snippet,
  desiredWidth = 217,
  desiredNumberOfLines = 5,
) => {
  const hiddenDiv = document.createElement('div');
  hiddenDiv.style.visibility = 'hidden';
  hiddenDiv.style.position = 'absolute';
  hiddenDiv.style.top = '-9999px';
  hiddenDiv.style.left = '-9999px';
  hiddenDiv.style.wordBreak = 'break-word';

  hiddenDiv.innerHTML = snippet;

  document.body.appendChild(hiddenDiv);

  const lineHeight = hiddenDiv.offsetHeight;
  const desiredHeight = lineHeight * desiredNumberOfLines;

  hiddenDiv.style.width = `${desiredWidth}px`;

  const maxCharsForGivenWidth =
    (desiredWidth / APPROX_WIDTH_OF_A_PERIOD) * desiredNumberOfLines;

  let currentHeight = hiddenDiv.offsetHeight;
  let truncatedText =
    snippet?.length > maxCharsForGivenWidth
      ? snippet.slice(0, maxCharsForGivenWidth)
      : snippet;

  while (currentHeight > desiredHeight && truncatedText.length > 0) {
    truncatedText = truncatedText.slice(0, -4) + '...';
    hiddenDiv.innerHTML = truncatedText;
    currentHeight = hiddenDiv.offsetHeight;
  }

  document.body.removeChild(hiddenDiv);

  return truncatedText;
};

export default truncateSnippet;
